import moment from 'moment';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ASAP, dateHelper, IOrderDelivery, ngHelper } from '@cakeiteasy/web-utils';

import { CART_DELIVERY_TYPES, DELIVERY_ORDER_DELIVERY_TYPES } from '../../../cart';
import { IGiftRecipientsData } from '../../models';

@Component({
  standalone: false,
  selector: 'gift-delivery',
  templateUrl: './gift-delivery.component.html',
  styleUrls: ['./gift-delivery.component.scss']
})
export class GiftDeliveryComponent implements OnInit, OnChanges {
  @Input() currency = 'kr';
  @Input() countryCode: string;
  @Input() deliveryDeposit: number;
  @Input() delivery: IOrderDelivery;
  @Input() pickupPointsCount: number;
  @Input() isToDoorAvailable: boolean;
  @Input() isPickUpAvailable: boolean;

  @Output() onDataChanged = new EventEmitter<any>();
  @Output() onNext = new EventEmitter<any>();
  @Output() onShowOutletsMap = new EventEmitter<void>();

  public recipientFormIsValid = false;

  public get isDeliveryValid() {
    return (this.isPickUpAvailable || this.isToDoorAvailable)
      && this._checkGiftDelivery(this._getRawDeliveryData()) && this.recipientFormIsValid;
  }

  public selectedTimeRange: string;
  public timeRanges: string[];
  public selectedDate = null;
  public type: string = CART_DELIVERY_TYPES.DELIVERY;
  public sendMailAsap = null;
  public readonly today = moment().toDate();

  public CART_DELIVERY_TYPES = CART_DELIVERY_TYPES;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    ngHelper.ifChanged(changes, 'delivery', delivery => {
      const { sendEmailTime, sendEmailDate, type } = delivery;
      this.sendMailAsap = Boolean(sendEmailTime && sendEmailDate) ? null : ASAP;
      this.type = type || CART_DELIVERY_TYPES.DELIVERY;

      this.selectedDate = sendEmailDate && moment(sendEmailDate, 'YYYY-MM-DD').toDate() || null;
      this.selectedTimeRange = sendEmailTime || '';
    });

    ngHelper.ifChanged(changes, 'isToDoorAvailable', isToDoorAvailable => {
      this.type = isToDoorAvailable ? this.type : CART_DELIVERY_TYPES.PICKUP;
    });
  }

  ngOnInit() {
    this.timeRanges = this._getTimeRanges();
  }

  public sendMessageSelectorChanged(event) {
    this.sendMailAsap = event;

    if (!event) {
      this.selectedDate = this.selectedDate || dateHelper.getTomorrowDate();
    }
  }

  public recipientsDataChanged(data: IGiftRecipientsData) {
    this.delivery = { ...this.delivery, ...data };
  }

  public submit() {
    this.onNext.emit(this._getRawDeliveryData());
  }

  private _checkGiftDelivery(delivery: IOrderDelivery) {
    const { deliveryPhone, deliveryUserName, sendEmailDate, sendEmailTime } = delivery;
    const timeIsValid = this.sendMailAsap === ASAP || Boolean(sendEmailDate && sendEmailTime);
    const isValid = [deliveryPhone, deliveryUserName].every(Boolean) && timeIsValid;

    return isValid;
  }


  private _getRawDeliveryData() {
    let sendEmailTime = '';
    let sendEmailDate = null;

    if (!this.sendMailAsap) {
      sendEmailTime = this.selectedTimeRange;
      sendEmailDate = moment(this.selectedDate).format('YYYY-MM-DD');
    }

    return {
      ...this.delivery,
      type: this.type,
      sendEmailDate,
      sendEmailTime,
      deliveryType: DELIVERY_ORDER_DELIVERY_TYPES.GIFT,
    };
  }

  private _getTimeRanges() {
    const ranges = [];

    for (let hour = 0; hour <= 23; hour++) {
      const range = `${hour < 10 ? '0' + hour : hour}:00`;
      ranges.push(range);
    }

    return ranges;
  }
}
